import React from 'react';
interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
}
export function Tabs({
  tabs,
  activeTab,
  onChange
}: TabsProps) {
  return <div className="sticky top-0 z-30 bg-white border-b border-gray-200 overflow-x-auto no-scrollbar" data-id="element-381">
      <div className="flex space-x-1 px-4 min-w-max" data-id="element-382">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className={`
                flex items-center px-4 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap
                ${isActive ? 'border-primary-purple text-primary-purple' : 'border-transparent text-text-secondary hover:text-text-primary hover:border-gray-300'}
              `} data-id="element-383">
              {tab.icon && <span className="mr-2" data-id="element-384">{tab.icon}</span>}
              {tab.label}
            </button>;
      })}
      </div>
    </div>;
}